import { defineStore } from 'pinia'

export const useModalStore = defineStore('modal', {
  state: () => ({
    confirmInfo: {},
    uploadInfo: {}
  }),
  actions: {
    openModal(key = '', info = {}) {
      if (this[key]) {
        this[key] = {
          visible: true,
          ...info
        }
      }
    },
    closeModal(key = '') {
      if (this[key]) {
        this[key].onCancel?.()
        this[key] = {}
      }
    },
    async confirmModal(key = 'confirmInfo', params) {
      const onConfirm = this[key]?.onConfirm
      if (onConfirm) {
        try {
          const ignoreClose = await onConfirm(params)
          if (!ignoreClose) {
            this.closeModal(key)
          }
        } catch (error) {
          console.error(error)
        }
      } else {
        this.closeModal(key)
      }
    }
  }
})
